export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "refusal_reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motif envoyé au client"])},
        "prefilled_by_agent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pré-rempli par l'agent"])},
        "restore_draft": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rétablir"])},
        "internal_notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notes internes (optionnel)"])},
        "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer le refus"])},
        "client_notified": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le client sera notifié par email."])}
      },
      "en": {
        "refusal_reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reason sent to the customer"])},
        "prefilled_by_agent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prefilled by the agent"])},
        "restore_draft": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Restore"])},
        "internal_notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internal notes (optional)"])},
        "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm the refusal"])},
        "client_notified": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The customer will be notified by email."])}
      }
    }
  })
}
